interface PillTabProps {
  label: string;
  /** 건수. **모를 때는 넘기지 않는다** — 0 을 그리면 「이 칸은 비었다」로 읽힌다. */
  count?: number;
  isActive: boolean;
  onClick: () => void;
  /** 비활성 탭에 빨간 점(미확인 항목). 상세 「대화」 탭이 쓴다. 활성이면 안 그린다. */
  hasAlert?: boolean;
  /** 상세 「파일/대화」 탭은 활성색이 한 톤 다르다(`#3A4150`, 기획 `xTabs`). */
  tone?: 'default' | 'detail';
}

/**
 * 알약 탭(계획서 G4) — 활성 `#3D4652` 흰 글자, 비활성 흰 바탕 + `rgba(16,27,51,.12)` 테두리.
 * 건수는 활성 `rgba(255,255,255,.7)` / 비활성 `text-assistive`. 패딩 `10px 16px`, 13px/600.
 *
 * 내 의뢰 목록·결제 내역·상세 「주고받은 내역」이 같은 모양이다. `shrink-0`·`whitespace-nowrap` 은
 * 375px 에서 세 알약이 한 줄에 안 들어갈 때 라벨이 쪼개지는 대신 가로로 넘치게 하려는 것이다(부모가 스크롤을 준다).
 */
const PillTab = ({ label, count, isActive, onClick, hasAlert = false, tone = 'default' }: PillTabProps) => {
  const activeClass = tone === 'detail' ? 'border-mp-tabDetail bg-mp-tabDetail text-white' : 'border-mp-tab bg-mp-tab text-white';

  return (
    <button
      type="button"
      aria-pressed={isActive}
      onClick={onClick}
      className={`relative inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border px-4 py-[10px] text-[13px] font-semibold leading-none transition-colors ${
        isActive ? activeClass : 'border-mp-lineSoft bg-white text-mp-neutral hover:bg-mp-chip'
      }`}
    >
      {label}
      {count !== undefined && <span className={`text-[12px] font-semibold ${isActive ? 'text-white/70' : 'text-mp-assistive'}`}>{count}</span>}
      {hasAlert && !isActive && <span aria-hidden="true" className="absolute -right-0.5 -top-0.5 h-2 w-2 rounded-full border-2 border-white bg-mp-red" />}
    </button>
  );
};

export default PillTab;
